import React from "react";
import { BrowserRouter, Navigate, useRoutes } from "react-router-dom";
import Admin from "./components/admin/Admin";
import Games from "./components/games/Games";
import Game from "./components/games/Game";
import Statistics from "./components/Statistics";
import QuestionPreview from "./components/games/QuestionPreview";

const Root = () => {

    const isNettivisa = typeof window !== 'undefined' && (
        /(^|\.)nettivisa\.fi$/i.test(window.location.hostname) ||
        (window.location.hostname === 'demo.nettivisa.fi' && window.location.port === '8000') ||
        (window.location.hostname === 'demo.nettivisa.fi' && window.location.port === '3000')
    );

    let routes;

    if(isNettivisa) {

        routes = [
            { path: '/:slug', element: <Game /> },
            { path: '/:slug/', element: <Game /> },
        ];

    }else{

        routes = [
            { path: '/', element: <Navigate to="/" replace /> },
            { path: '/admin/*', element: <Admin /> },
            { path: '/statistics/:slug/', element: <Statistics />},
            { path: '/games', element: <Games /> },
            { path: '/games/:slug', element: <Game /> },
        ];

    }

    return useRoutes(routes);
};

const AppRoutes = () => {

    return (
        <BrowserRouter>
            <Root />
        </BrowserRouter>
    )
}

export default AppRoutes;
